<div mat-dialog-title>
    {{ organizeType.value | translate }}
</div>
<div mat-dialog-content>
    <div class="spinner-center" *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>

    <ng-container *ngIf="!loading">
        <form [formGroup]="formGroup" class="dragAndDrop-container">
            <div class="dragAndDrop-div">
                <h2 *ngIf="organizeType.key === OrganizeTypes.REORGANIZE_AND_MOVE">{{
                    'DEUSTO.ACTIONS.ORGANIZE.FIELDS.ORIGIN' | translate }}</h2>
                <smt-search-select [useChips] = "false" [group]="formGroup" [controlName]="'originDeposit'"
                    [label]="'DEUSTO.ACTIONS.ORGANIZE.FIELDS.DEPOSIT'" [options]="depositOptions"
                    (optionSelected)="originInstallationUnit.value = ''; enableControl('originInstallationUnit')"></smt-search-select>

                <mat-form-field>
                    <mat-label>{{'DEUSTO.ACTIONS.ORGANIZE.FIELDS.INSTALLATION_UNIT' | translate}}</mat-label>
                    <input type="text" matInput #originInstallationUnit formControlName="originInstallationUnit" [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate" (keydown.enter)="getOriginDocuments()" (input)="checkIfEnableDestinationInstallationUnit(); formGroup.get('originRegisters').setValue(null)">
                    <div matSuffix class="app-suffix-search-icon-wrapper">
                        <button type="button"  mat-icon-button (click)="getOriginDocuments()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                    <mat-error *ngIf="formGroup.get('originInstallationUnit').hasError('minlength')">
                        {{ 'ALDEN.VALIDATORS.ERRORS.MIN_LENGTH' | translate : { length: 3 } }}
                    </mat-error>
                    <mat-error
                        *ngIf="formGroup.get('originInstallationUnit').hasError('pattern') && !formGroup.get('originInstallationUnit').hasError('minlength')">
                        {{ 'ALDEN.VALIDATORS.ERRORS.PATTERN' | translate }}
                    </mat-error>
                </mat-form-field>

                <div class="spinner-center" *ngIf="loadingOrigin">
                    <mat-spinner></mat-spinner>
                </div>
                <!--<ng-container *ngIf="formGroup.controls['originInstallationUnit'].valid && loadingOrigin === false">
                    <div cdkDropList #originList="cdkDropList"
                        [cdkDropListData]="formGroup.controls['originRegisters'].value"
                        [cdkDropListConnectedTo]="organizeType.key === OrganizeTypes.REORGANIZE_AND_MOVE ? [destinationList] : []"
                        class="dragAndDrop-list" [ngStyle]="originList.data ? { display: 'block'} : { display: 'none'}"
                        (cdkDropListDropped)="drop($event)">
                        <div class="dragAndDrop-box" *ngFor="let item of originList.data; let i = index" cdkDrag>
                            {{i+1}}. {{item.signatura}} ({{item.recordName}})</div>
                        <div class="dragAndDrop-box" *ngIf="originList?.data?.length == 0">{{
                            'DEUSTO.ACTIONS.ORGANIZE.MESSAGES.EMPTY_ITEM' | translate }}</div>
                    </div>
                </ng-container>--> 
                <ng-container *ngIf="formGroup.controls['originInstallationUnit'].valid && loadingOrigin === false">
                    <div cdkDropList #originList="cdkDropList" [cdkDropListData]="formGroup.controls['originRegisters'].value"
                        [cdkDropListConnectedTo]="organizeType.key === OrganizeTypes.REORGANIZE_AND_MOVE ? [destinationList] : []"
                        class="dragAndDrop-list" [ngStyle]="originList.data ? { display: 'block'} : { display: 'none'}"
                        (cdkDropListDropped)="drop($event)">
                
                        <div class="dragAndDrop-box" *ngIf="originList.data?.length > 0 && organizeType.key === OrganizeTypes.REORGANIZE_AND_MOVE">
                            <input type="checkbox" [checked]="allOriginSelected" (change)="toggleAllOriginSelection($event)">Seleccionar todos
                        </div>
                
                        <div class="dragAndDrop-box" *ngFor="let item of originList.data; let i = index" cdkDrag [cdkDragData]="item" (cdkDragStarted)="dragStarted()" (cdkDragEnded)="dragEnded()"  [class.drag-hidden]="isDragging && item.selected">
                            <input type="checkbox" [checked]="item.selected" (change)="toggleOriginSelection(item)">
                            {{i+1}}. {{item.signatura}} ({{item.recordName}})
                            <ng-template cdkDragPreview>
                                <div class="drag-counter">
                                    {{ getDragCount(item) }}
                                    {{ getDragCount(item) === 1 ? 'elemento' : 'elementos' }}
                                </div>
                            </ng-template>
                        </div>
                        <div class="dragAndDrop-box" *ngIf="originList?.data?.length == 0">
                            {{ 'DEUSTO.ACTIONS.ORGANIZE.MESSAGES.EMPTY_ITEM' | translate }}
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="dragAndDrop-div" *ngIf="organizeType.key === OrganizeTypes.REORGANIZE_AND_MOVE">
                <h2>{{ 'DEUSTO.ACTIONS.ORGANIZE.FIELDS.DESTINATION' | translate }}</h2>
                <smt-search-select [useChips] = "false" [group]="formGroup" [controlName]="'destinationDeposit'"
                    [label]="'DEUSTO.ACTIONS.ORGANIZE.FIELDS.DEPOSIT'" [options]="depositOptions"
                    [disabled]="!formGroup.controls['originInstallationUnit'].valid"
                    (optionSelected)="destinationInstallationUnit.value = ''; enableControl('destinationInstallationUnit')"></smt-search-select>

                <mat-form-field>
                    <mat-label>{{'DEUSTO.ACTIONS.ORGANIZE.FIELDS.INSTALLATION_UNIT' | translate}}</mat-label>
                    <input type="text" matInput #destinationInstallationUnit formControlName="destinationInstallationUnit" [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate" (keydown.enter)="getDestinationDocuments()" (input)="formGroup.get('destinationRegisters').setValue(null)">
                    <div matSuffix class="app-suffix-search-icon-wrapper">
                        <button type="button" mat-icon-button (click)="getDestinationDocuments()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>

                    <mat-error *ngIf="formGroup.get('destinationInstallationUnit').hasError('minlength')">
                        {{ 'ALDEN.VALIDATORS.ERRORS.MIN_LENGTH' | translate : { length: 3 } }}
                    </mat-error>
                    <mat-error
                        *ngIf="formGroup.get('destinationInstallationUnit').hasError('pattern') && !formGroup.get('destinationInstallationUnit').hasError('minlength')">
                        {{ 'ALDEN.VALIDATORS.ERRORS.PATTERN' | translate }}
                    </mat-error>
                    <mat-error
                        *ngIf="formGroup.get('destinationInstallationUnit').hasError('destination') && !formGroup.get('destinationInstallationUnit').hasError('pattern')">
                        {{ 'DEUSTO.ACTIONS.ORGANIZE.ERRORS.DESTINATION' | translate }}
                    </mat-error>
                </mat-form-field>

                <div class="spinner-center" *ngIf="loadingDestination">
                    <mat-spinner></mat-spinner>
                </div>
                <ng-container
                    *ngIf="formGroup.controls['destinationInstallationUnit'].valid && loadingDestination === false">
                    <div cdkDropList #destinationList="cdkDropList"
                        [cdkDropListData]="formGroup.controls['destinationRegisters'].value"
                        [cdkDropListConnectedTo]="originList ? [originList] : []" class="dragAndDrop-list"
                        [ngStyle]="destinationList.data ? { display: 'block'} : { display: 'none'}"
                        (cdkDropListDropped)="drop($event)">
                        <div class="dragAndDrop-box" *ngFor="let item of destinationList.data; let i = index" cdkDrag>
                            {{i+1}}. {{item.signatura}} ({{item.recordName}})</div>
                        <div class="dragAndDrop-box" *ngIf="destinationList.data.length == 0">{{
                            'DEUSTO.ACTIONS.ORGANIZE.MESSAGES.EMPTY_ITEM' | translate }}</div>
                    </div>
                </ng-container>
            </div>
        </form>
    </ng-container>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="accent">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.NO_LABEL' | translate }}
    </button>
    <button mat-raised-button [disabled]="(organizeType.key === OrganizeTypes.REORGANIZE && formGroup.get('originRegisters').value?.length < 1) || (organizeType.key === OrganizeTypes.REORGANIZE_AND_MOVE && !formGroup.get('destinationInstallationUnit').value)" color="primary" (click)="sendReorganize()">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.YES_LABEL' | translate }}
    </button>
</div>